<template>
    <skutopia>
        <!-- POG Header -->
        <div class="d-flex justify-space-between align-center flex-wrap gap-y-4 mb-6">
            <div>
                <div class="d-flex gap-2 align-center mb-2 flex-wrap">
                <h5 class="text-h5 mr-3">
                    {{localPOG.project}} - POG #{{ localPOG.id }}
                </h5>
                <div class="d-flex gap-x-2" v-if="localPOG.status">
                    <v-chip
                        :color="resolveStatus(localPOG.status).color"
                        small
                    >
                    {{ resolveStatus(localPOG.status).text }}
                    </v-chip>

                </div>
                </div>
                <div>
                <span class="text-body-1">
                    Created: {{formatDate(localPOG.created_at)}}
                </span>
                </div>
                <div>
                <span class="text-body-1">
                    Last updated: {{formatDate(localPOG.updated_at)}}
                </span>
                </div>
            </div>

            <v-btn
                outlined
                color="error"
                @click="isDeleteConfirmDialogVisible = !isDeleteConfirmDialogVisible"
                v-if="$can('update','skutopia')"
            >
                Delete POG
            </v-btn>
            </div>
                        <v-row>
                <v-col
                    cols="12"
                    md="12"
                >
                    <!-- 👉 POG Details -->
                    <v-card class="mb-6">

                        <v-card-title>
                            POG Details
                            <v-spacer></v-spacer>
                            <v-menu
                                bottom
                                left
                                v-if="$can('update','skutopia')"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                                </v-btn>
                                </template>

                                <v-list>
                                    <v-list-item
                                        @click="isPOGEdit = true"
                                    >    
                                        <v-list-item-title>
                                        <v-icon
                                            size="20"
                                            class="me-2"
                                        >
                                            {{ icons.mdiSquareEditOutline }}
                                        </v-icon>
                                        <span>Update POG Status</span>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-avatar
                                    v-if="localPOG"
                                    size="34"
                                    color="primary"
                                    class="me-3"
                                >
                                    <span
                                    class="font-weight-medium white--text "
                                    >{{ avatarText(localPOG.created_by) }}</span>
                                </v-avatar>
                                <div>
                                    <div class="text-body-1 font-weight-medium">
                                    {{ localPOG.created_by }}
                                    </div>
                                    <span>Creator</span>
                                </div>
                            </div>

                            <div class="d-flex align-center mb-2">
                                <v-avatar
                                    color="success"
                                    size="34"
                                    class="me-3"
                                >
                                    <v-icon 
                                    size="20">{{ icons.mdiCartOutline }}</v-icon>
                                </v-avatar>

                                <div class="text-body-1 font-weight-medium">
                                    {{ productsData.length }} Products in the POG
                                </div>
                            </div>
                            <div class="d-flex align-center mb-2" v-if="missingProducts.length">
                                <v-avatar
                                    color="error"
                                    size="34"
                                    class="me-3"
                                >
                                    <v-icon
                                    size="20" dark>{{ icons.mdiCartOutline }}</v-icon>
                                </v-avatar>

                                <div class="text-body-1 font-weight-medium">
                                    {{ missingProducts.length }} Missing Products Images
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-text v-if="localPOG.comments">
                            Comments: 
                            <p>{{ localPOG.comments }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-alert
            v-if="localPOG.status === 'INCO'"
            type="warning"
            dense
            prominent
            class="mb-6"
            border="left"
            >
            <div class="d-flex align-center">
                <div>
                <div class="font-weight-bold"> This POG is incomplete</div>
                <div class="text-body-2">
                    {{ unresolvedProducts.length }} product(s) could not be automatically found. 
                    Please resolve them before finalizing the POG.
                </div>
                </div>
                <v-spacer />
                <v-btn
                color="warning"
                outlined
                small
                @click="isResolveDialogOpen = true"
                >
                Resolve now →
                </v-btn>
            </div>
            </v-alert>

            <!-- 👉 POG Shelf Image -->
            <v-card class="mb-6" :loading="imageLoading">
                <v-card-title>
                    Shelf Image Preview
                    <v-spacer></v-spacer>
                    <v-menu
                        bottom
                        left
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                        </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                @click="onFileChange"
                                v-if="$can('add','skutopia')"
                            >
                                <v-list-item-title>
                                    <v-icon
                                        size="20"
                                        class="me-2"
                                    >
                                        {{ icons.mdiTrayArrowUp }}
                                    </v-icon>
                                    <span>Upload Shelf Image</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="downloadShelf"
                            >
                                <v-list-item-title>
                                    <v-icon
                                        size="20"
                                        class="me-2"
                                    >
                                        {{ icons.mdiDownload }}
                                    </v-icon>
                                    <span>Download Shelf Img</span>
                                </v-list-item-title>
                            </v-list-item>

                        </v-list>
                    </v-menu>

            </v-card-title>

            <v-card-text>
                <SecureImage :src="localPOG.shelf_thumbnail" style="border: 1px dashed #ccc; min-height: 250px" />
            </v-card-text>
        </v-card>

        <!-- Product Details Card Grid -->
    <v-row>
      <v-col cols="12" md="12">
        <v-card class="mb-6">
          <v-card-title>
            Product Details
            <v-spacer></v-spacer>

             <!-- Toggle between list and card view -->
              
            <v-btn-toggle v-model="isCardView" dense>
            <v-btn :value="true" small class="d-flex justify-center align-center">
              <v-icon small class="mr-1">{{ icons.mdiViewGrid }}</v-icon>
            </v-btn>
            <v-btn :value="false" small class="d-flex justify-center align-center">
              <v-icon small class="mr-1">{{icons.mdiViewList}}</v-icon>
            </v-btn>
          </v-btn-toggle>

            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="isProductListEdit = true"
                v-if="$can('update','skutopia')">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiTrayArrowUp }}</v-icon>
                    <span>Upload Updated Product List</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadPOG">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiFormatListBulletedSquare }}</v-icon>
                    <span>Download POG File</span>
                  </v-list-item-title>
                </v-list-item>
                
                <v-list-item @click="downloadDocx">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiFileWordOutline }}</v-icon>
                    <span>Download Existing Images Docx</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadMissing">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiLocationExit }}</v-icon>
                    <span>Download Missing Products</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="isPNGDownload = true"
                >
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiDownload }}</v-icon>
                    <span>Download PNGs</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadPSD"
                    v-if="$can('add','skutopia')">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiImageAlbum }}</v-icon>
                    <span>Download PSD</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>

          <v-card-text>
          <!-- Card View -->
          <v-row dense v-if="isCardView">
            <v-col
              v-for="(item, index) in productsData"
              :key="index"
              cols="12"
              sm="6"
              md="3"
              lg="2"
            >
                <v-card outlined class="pa-3 d-flex flex-column justify-space-between h-100">
                  <div class="text-center mb-2">
                    <v-chip small color="info" outlined>{{ item.shelf_code || 'No Shelf Code' }}</v-chip>
                  </div>
                  <!-- Image with placeholder -->
                  <v-avatar
                    rounded = "0"
                    size="120"
                    class="mb-2 align-self-center"
                    v-if="item.product && item.product.images && item.product.images.length"
                    @click="openOverlay(item.product.images[0])"
                  >
                    <SecureImage
                      :src="item.product.images[0].thumbnail"
                      :alt="item.product.name"
                      contain
                    />
                  </v-avatar>

                  <!-- Placeholder when no image -->
                  <v-avatar size="120" class="mb-2 d-flex align-center justify-center mx-auto"  v-else>
                    <v-icon size="48" color="grey lighten-1">
                      {{icons.mdiCameraOff}}
                    </v-icon>
                  </v-avatar>


                  <!-- Product Name & Brand -->
                  <router-link v-if="item.product" :to="{ name: 'product-id', params: { id: item.product.barcode } }">
                    <div class="text-center mb-1">
                        <span class="font-weight-medium text-high-emphasis text-truncate d-block">{{ item.label }}</span>
                        <small class="text-muted">{{ item.product.brand ? item.product.brand.name : '' }}</small>
                    </div>
                    </router-link>
                    <div v-else class="text-center mb-1">
                    <!-- Excluded/parked -->
                    <template v-if="item.is_excluded">
                      <span class="font-weight-medium red--text text-truncate d-block">
                        {{ item.pending_variant || '(no name)' }}
                      </span>
                      <small class="text-muted">
                        {{ item.pending_brand || '(no brand)' }} · {{ item.pending_upc }}
                      </small>
                      <div class="mt-2">
                        <v-chip x-small color="error" class="mb-1">Not found</v-chip>
                        <div>
                          <v-btn x-small color="error" outlined @click="isResolveDialogOpen = true">
                            <v-icon left x-small>{{ icons.mdiAlertCircle }}</v-icon>
                            Review
                          </v-btn>
                        </div>
                      </div>
                    </template>

                    <template v-else>
                      <span class="font-weight-medium orange--text text-truncate d-block">
                        {{ item.pending_variant || '(no name)' }}
                      </span>
                      <small class="text-muted">
                        {{ item.pending_brand || '(no brand)' }} · {{ item.pending_upc }}
                      </small>
                      <div class="mt-2">
                        <v-btn x-small color="warning" outlined @click="isResolveDialogOpen = true">
                          <v-icon left x-small>{{ icons.mdiAlertCircle }}</v-icon>
                          Resolve
                        </v-btn>
                      </div>
                    </template>
                  </div>

                  <!-- Price -->
                  <div class="text-center mb-1">
                    <span class="font-weight-medium">{{ currencyFormatter ? currencyFormatter.format(item.price || 0) : '' }}</span>
                </div>

                  <!-- Stackings / Facings -->
                  <div class="d-flex justify-space-between mb-1">
                    <v-chip small outlined color="primary">{{ item.stackings }} stack</v-chip>
                    <v-chip small outlined color="secondary">{{ item.facings }} facings</v-chip>
                  </div>

                  <!-- Digital Switch -->
                  <div class="d-flex justify-center align-center mb-1">
                    <v-checkbox
                      v-model="item.digital"
                      @change="handleDigitalChange(item)"
                      dense
                      hide-details
                    />
                    <span class="ml-2 text-sm">Digital</span>
                  </div>

                    <!-- Last Uploaded -->
                    <div class="text-center text-xs text-muted">
                    <span v-if="item.product && item.product.images && item.product.images.length > 0">
                        Uploaded: {{ item.product.images[0].uploaded_at }}
                    </span>
                    </div>
                </v-card>
              </v-col>
            </v-row>

           <!-- List View -->
           <v-data-table
              v-else
              :headers="POGProductHeader"
              :items="productsData"
              item-value="productName"
              class="text-no-wrap"
              :loading="pogLoading"
              dense
              hide-default-footer
              disable-pagination
            >
                    <template #item.product="{ item }">
                      <div v-if="!item.product" class="d-flex align-center gap-x-4 cursor-pointer" @click="isResolveDialogOpen = true">
                        <v-avatar size="38" rounded="0" class="mr-3">
                          <v-icon :color="item.is_excluded ? 'error' : 'warning'">{{ icons.mdiAlertCircle }}</v-icon>
                        </v-avatar>
                        <div class="d-flex flex-column">
                          <span :class="item.is_excluded ? 'red--text' : 'orange--text'" class="font-weight-medium">
                            {{ item.pending_variant || item.label || '(no name)' }}
                          </span>
                          <span class="text-caption grey--text">
                            {{ item.pending_brand || '(no brand)' }} · {{ item.pending_upc }}
                          </span>
                          <span class="text-caption" :class="item.is_excluded ? 'error--text' : 'warning--text'">
                            {{ item.is_excluded ? 'Not found — click to review →' : 'Click to resolve →' }}
                          </span>
                        </div>
                      </div>
                    <div v-else class="d-flex align-center gap-x-4 cursor-pointer text-truncate">
                        <v-avatar
                        v-if="item.product.images && item.product.images.length > 0"
                        size="38" rounded="0" class="mr-3"
                        @click="openOverlay(item.product.images[0])"
                        >
                        <SecureImage :alt="item.product.name" :src="item.product.images[0].thumbnail" contain />
                        </v-avatar>
                        <router-link :to="{ name: 'product-id', params: { id: item.product.barcode } }">
                        <div class="d-flex flex-column">
                            <span class="text-high-emphasis font-weight-medium overflow-x-hidden">{{ item.label }}</span>
                            <a class="text-sm">{{ item.product.brand ? item.product.brand.name : '' }}</a>
                        </div>
                        </router-link>
                    </div>
                    </template>

                    <template #item.price="{ item }">
                        <span>{{ currencyFormatter ? currencyFormatter.format(item.price || 0) : '' }}</span>
                    </template>

                    <template #item.stackings="{ item }">
                        <span>
                            {{ item.stackings }}
                        </span>
                    </template>

                    <!-- stock -->
                    <template #item.digital="{ item }">
                        <v-checkbox v-model="item.digital" @change="handleDigitalChange(item)"/>
                    </template>

                    <template #item.uploaded_at="{ item }">
                    <span v-if="item.product && item.product.images && item.product.images.length > 0">
                        {{ item.product.images[0].uploaded_at }}
                    </span>
                    <span v-else-if="item.is_unresolved" class="orange--text text-caption">En attente</span>
                    </template>
                    <template #bottom />
                </v-data-table>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- PNG Download Dialog -->
    <p-n-g-download-edit
      :is-dialog-edit.sync="isPNGDownload"
      :loading="downloadLoading"
      @download="downloadPNGs"
      @download-decipher="downloadDecipherPNGs"
    >
    </p-n-g-download-edit>

    <!-- Product List Edit Dialog -->
    <v-dialog v-model="isProductListEdit" width="400px" @click:outside="$emit('update:is-product-list-edit',false)">
      <v-card>
        <v-card-text>
          <div class="flex">
            <div class="w-full h-auto relative">
              <div ref="dropZoneRef" class="cursor-pointer" @click="() => openFile()">
                <div class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded">
                  <v-btn outlined color="secondary" class="rounded" size="30">
                    <v-icon size="24">{{ icons.mdiTrayArrowUp }}</v-icon>
                  </v-btn>
                  <span class="text-h6">Click to upload your POG File here.</span>
                </div>
                <div class="drop-zone" v-if="pogFiles.length > 0">
                  <v-list-item
                    v-for="(item, index) in pogFiles"
                    :key="index"
                    @click.stop
                  >
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
                    <template v-slot:append>
                      <v-list-item-action class="align-end">
                        <v-btn @click.stop="pogFiles.splice(index, 1)">X</v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined class="mr-2" @click="cancelProductListEdit">Cancel</v-btn>
          <v-btn color="primary" outlined :loading="planogramUploadLoading" @click="uploadProductList">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- POG Edit Dialog -->
    <v-dialog
        v-model="isPOGEdit"
        width="750px"
        @click:outside="$emit('update:isPOGEdit',false)"
    >
        <v-card>
            <v-card-title>Edit POG</v-card-title>
            <v-card-text>
                <v-select
                    v-model="localPOG.status"
                    :items="pogStatus"
                    label="Status"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                >

                </v-select>
                

                <v-textarea
                    v-model="localPOG.comments"
                    label="Comments"
                    rows="3"
                    outlined
                    dense
                    hide-details
                    placeholder="Comments"
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text outlined class="mr-2" @click="cancelPOGEdit">Cancel</v-btn>
                <v-btn color="primary" outlined :loading="planogramUploadLoading" @click="updatePOG">Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- POG Delete Dialog -->
    <v-dialog v-model="isDeleteConfirmDialogVisible" width="450px" @click:outside="$emit('update:is-delete-confirm-dialog-visible',false)">
      <v-card>
        <v-card-title>Delete POG Confirmation</v-card-title>
        <v-card-text>
          Do you want to delete the current POG?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined class="mr-2" @click="isDeleteConfirmDialogVisible = false">Cancel</v-btn>
          <v-btn color="error" outlined :loading="pogLoading" @click="deletePOGConfirmed(localPOG.id)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Overlay Dialog -->
    <v-dialog v-model="overlayOpen" width="80%">
      <v-card>
        <v-card-title>
          {{ selectedImage ? `${selectedImage.name} - ${selectedImage.side} - ${selectedImage.uploaded_at}` : '' }}
        </v-card-title>

        <SecureImage
          :src="selectedImage ? selectedImage.image : ''"
          :lazy_src="selectedImage ? selectedImage.thumbnail : ''"
          max-height="80vh"
          max-width="100%"
          contain
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
            </div>
          </template>
        </SecureImage>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeOverlay">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isResolveDialogOpen" max-width="900px" persistent>
        <v-card>
          <v-card-title class="d-flex align-center">
            Resolve incomplete products
            <v-spacer />
            <v-chip small :color="resolveAllDone ? 'success' : 'warning'">
              {{ resolveConfirmations.length }} / {{ unresolvedProducts.length }} resolved
            </v-chip>
          </v-card-title>

          <v-card-subtitle class="pt-1 pb-0">
            For each product below, confirm the correct match or mark as not found.
          </v-card-subtitle>

          <v-card-text v-if="resolveLoading" class="d-flex justify-center align-center py-10">
            <v-progress-circular indeterminate color="primary" />
          </v-card-text>

          <v-card-text v-else class="pt-4">
            <div v-for="pp in unresolvedProducts" :key="pp.id" class="mb-2">
              <v-card outlined :class="{
                'border-success': resolveDecisions[pp.id] && resolveDecisions[pp.id].confirmed_product_id !== null,
                'border-error': resolveDecisions[pp.id] && resolveDecisions[pp.id].confirmed_product_id === null && resolveDecisions[pp.id].is_excluded,
                'border-warning': !resolveDecisions[pp.id],
              }">

                <div
                  class="d-flex align-center px-4 py-3 cursor-pointer"
                  @click="toggleResolveItem(pp.id)"
                >
                  <v-chip x-small class="mr-2" color="primary" outlined>{{ pp.shelf_code }}</v-chip>
                  <div class="d-flex flex-column">
                    <span class="text-body-2 font-weight-medium">
                      {{ pp.pending_variant || pp.label || '(no name)' }}
                    </span>
                    <span class="text-caption grey--text">
                      {{ pp.pending_upc }} · {{ pp.pending_brand || '(no brand)' }}
                    </span>
                  </div>
                  <v-spacer />

                  <template v-if="resolveDecisions[pp.id]">
                    <v-icon v-if="resolveDecisions[pp.id].confirmed_product_id !== null || resolveDecisions[pp.id].create_product" color="success" small class="mr-1">
                      {{ icons.mdiCheckCircle }}
                    </v-icon>
                    <v-icon v-else color="error" small class="mr-1">
                      {{ icons.mdiClose }}
                    </v-icon>
                    <span class="text-caption mr-2" :class="resolveDecisions[pp.id].confirmed_product_id !== null || resolveDecisions[pp.id].create_product ? 'success--text' : 'error--text'">
                      {{ resolveDecisions[pp.id].confirmed_product_id !== null || resolveDecisions[pp.id].create_product
                        ? resolveDecisions[pp.id].confirmed_name || resolveDecisions[pp.id].manual_name
                        : 'Not found (Parked)' }}
                    </span>
                  </template>
                  <v-chip v-else x-small color="warning" class="mr-2">Pending</v-chip>

                  <v-icon small>
                    {{ activeResolveItem === pp.id ? icons.mdiChevronUp : icons.mdiChevronDown }}
                  </v-icon>
                </div>

                <div v-if="activeResolveItem === pp.id">
                  <v-divider />
                  <v-card-text>

                    <v-text-field
                      v-model="resolveSearchInputs[pp.id]"
                      placeholder="Search by UPC or name..."
                      outlined dense hide-details clearable
                      class="mb-3"
                      :loading="resolveSearchLoading[pp.id]"
                      @input="searchResolveProduct(pp.id)"
                      @keyup.enter="searchResolveProduct(pp.id)"
                    />

                    <v-row dense v-if="resolveCandidates[pp.id] && resolveCandidates[pp.id].length">
                      <v-col
                        v-for="match in resolveCandidates[pp.id]"
                        :key="match.id"
                        cols="12" sm="6" md="4"
                      >
                        <v-card
                          outlined
                          class="pa-3 d-flex flex-column align-center text-center cursor-pointer"
                          :style="resolveDecisions[pp.id] &&
                            resolveDecisions[pp.id].confirmed_product_id === match.id
                            ? 'border-color: #4caf50;' : ''"
                          @click="resolveSelectMatch(pp, match)"
                        >
                          <v-avatar size="56" rounded class="mb-2">
                            <SecureImage v-if="match.thumbnail" :src="match.thumbnail" contain />
                            <v-icon v-else size="32" color="grey lighten-1">{{ icons.mdiPackageVariant }}</v-icon>
                          </v-avatar>
                          <div class="text-body-2 font-weight-medium">{{ match.name }}</div>
                          <div class="text-caption grey--text">{{ match.barcode }}</div>
                          <div class="text-caption">{{ match.brand }}</div>
                          <v-btn
                            x-small outlined class="mt-2"
                            :color="resolveDecisions[pp.id] &&
                              resolveDecisions[pp.id].confirmed_product_id === match.id
                              ? 'success' : 'primary'"
                            @click.stop="resolveSelectMatch(pp, match)"
                          >
                            {{ resolveDecisions[pp.id] &&
                              resolveDecisions[pp.id].confirmed_product_id === match.id
                              ? '✓ Confirmed' : 'Confirm' }}
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-alert v-else type="info" dense text class="mb-3">
                      No product found automatically. Search above or enter manually below.
                    </v-alert>

                    <div v-if="manualEntryOpen[pp.id]" class="mt-3">
                    <v-divider class="mb-3" />
                    <div class="text-subtitle-2 mb-3">Enter product details manually</div>
                    
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="manualEntry[pp.id].upc"
                          label="UPC / EAN *"
                          outlined dense hide-details
                          :placeholder="pp.pending_upc"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="manualEntry[pp.id].name"
                          label="Product name *"
                          outlined dense hide-details
                          :placeholder="pp.pending_variant || pp.label"
                        />
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-text-field
                          :value="pp.pending_brand || '—'"
                          label="Brand (from Excel)"
                          outlined dense hide-details
                          readonly disabled
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          :value="pp.pending_variant || '—'"
                          label="Variant (from Excel)"
                          outlined dense hide-details
                          readonly disabled
                        />
                      </v-col>
                    </v-row>

                    <div class="d-flex align-center mt-3 mb-2">
                      <v-btn
                        small outlined color="primary"
                        :loading="manualSearchLoading[pp.id]"
                        :disabled="!manualEntry[pp.id].upc || manualEntry[pp.id].upc.length < 4"
                        @click="searchWithManualUPC(pp)"
                      >
                        <v-icon left small>{{ icons.mdiMagnify }}</v-icon>
                        Search with this UPC
                      </v-btn>
                      <span class="text-caption grey--text ml-3" v-if="manualSearchDone[pp.id] && !manualSearchResults[pp.id].length">
                        No product found — will create a new one on save
                      </span>
                    </div>

                    <v-row dense v-if="manualSearchResults[pp.id] && manualSearchResults[pp.id].length">
                      <v-col
                        v-for="match in manualSearchResults[pp.id]"
                        :key="match.id"
                        cols="12" sm="6" md="4"
                      >
                        <v-card
                          outlined
                          class="pa-3 d-flex flex-column align-center text-center cursor-pointer"
                          :style="resolveDecisions[pp.id] &&
                            resolveDecisions[pp.id].confirmed_product_id === match.id
                            ? 'border-color: #4caf50;' : ''"
                          @click="resolveSelectMatch(pp, match); toggleManualEntry(pp.id)"
                        >
                          <v-avatar size="56" rounded class="mb-2">
                            <SecureImage v-if="match.thumbnail" :src="match.thumbnail" contain />
                            <v-icon v-else size="32" color="grey lighten-1">{{ icons.mdiPackageVariant }}</v-icon>
                          </v-avatar>
                          <div class="text-body-2 font-weight-medium">{{ match.name }}</div>
                          <div class="text-caption grey--text">{{ match.barcode }}</div>
                          <div class="text-caption">{{ match.brand }}</div>
                          <v-btn
                            x-small outlined class="mt-2"
                            :color="resolveDecisions[pp.id] &&
                              resolveDecisions[pp.id].confirmed_product_id === match.id
                              ? 'success' : 'primary'"
                            @click.stop="resolveSelectMatch(pp, match); toggleManualEntry(pp.id)"
                          >
                            {{ resolveDecisions[pp.id] &&
                              resolveDecisions[pp.id].confirmed_product_id === match.id
                              ? '✓ Confirmed' : 'Confirm' }}
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-alert
                      v-if="manualSearchDone[pp.id] && !manualSearchResults[pp.id].length"
                      type="info" dense text class="mt-2 mb-3"
                    >
                      No existing product found for <strong>{{ manualEntry[pp.id].upc }}</strong>.
                      Clicking "Save & create" will add it to the catalog using the Excel data.
                    </v-alert>

                    <div class="d-flex justify-end mt-3">
                      <v-btn small text class="mr-2" @click="toggleManualEntry(pp.id)">Cancel</v-btn>
                      <v-btn
                        small color="primary" outlined
                        :disabled="!manualEntry[pp.id].upc || !manualEntry[pp.id].name"
                        :loading="manualSaveLoading[pp.id]"
                        @click="confirmManualEntry(pp)"
                      >
                        {{ manualSearchDone[pp.id] && !manualSearchResults[pp.id].length
                          ? 'Save & create product'
                          : 'Save & confirm' }}
                      </v-btn>
                    </div>
                  </div>

                    <div class="d-flex justify-space-between align-center mt-3">
                      <v-btn x-small text color="primary" @click="toggleManualEntry(pp.id)">
                        <v-icon left x-small>{{ icons.mdiPencil }}</v-icon>
                        {{ manualEntryOpen[pp.id] ? 'Cancel manual entry' : 'Enter manually' }}
                      </v-btn>
                      <v-btn
                        x-small text
                        :color="resolveDecisions[pp.id] &&
                          resolveDecisions[pp.id].is_excluded ? 'error' : 'grey'"
                        @click="resolveMarkExcluded(pp)"
                      >
                        <v-icon left x-small>{{ icons.mdiClose }}</v-icon>
                        {{ resolveDecisions[pp.id] &&
                          resolveDecisions[pp.id].is_excluded
                          ? 'Marked: Not found (Parked)' : 'Mark as not found (Park)' }}
                      </v-btn>
                    </div>

                  </v-card-text>
                </div>
              </v-card>
            </div>
          </v-card-text>

          <v-card-actions class="px-4 pb-4">
            <v-btn text outlined @click="isResolveDialogOpen = false">Cancel</v-btn>
            <v-spacer />
            
            <v-btn
              v-if="!resolveAllDone"
              text
              color="primary"
              class="ml-3 mr-3"
              @click="markRemainingResolveAsManualEntry"
            >
              <v-icon left small>{{ icons.mdiPencil }}</v-icon>
              Mark remaining to auto-create
            </v-btn>

            <span class="text-caption grey--text mr-4" v-if="!resolveAllDone">
              {{ unresolvedProducts.length - resolveConfirmations.length }} product(s) remaining
            </span>
            <v-btn
              color="primary" outlined
              :loading="resolveSubmitting"
              :disabled="!resolveAllDone || resolveSubmitting"
              @click="submitResolutions"
            >
              Confirm & Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="resolveSnackbar.show"
        :color="resolveSnackbar.color"
        top
        right
        :timeout="5000"
      >
        {{ resolveSnackbar.message }}
        <template #action="{ attrs }">
          <v-btn text v-bind="attrs" @click="resolveSnackbar.show = false">
            Dismiss
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="downloadConfirmDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>Download POG File</v-card-title>
          <v-card-text>
            <v-alert type="warning" dense text class="mb-4">
              This POG has <strong>{{ unresolvedProducts.length }}</strong> product(s) with missing information.
            </v-alert>
            <p class="mb-4">What would you like to do with them?</p>

            <v-btn
              color="primary" outlined block large class="mb-1"
              @click="confirmDownloadPOG(true)"
            >
              <v-icon left>{{ icons.mdiDownload }}</v-icon>
              Include as placeholders
            </v-btn>
            <p class="text-caption grey--text mb-4 ml-1">Pending UPC and name shown as-is</p>

            <v-btn
              outlined block large class="mb-1"
              @click="confirmDownloadPOG(false)"
            >
              <v-icon left>{{ icons.mdiDownload }}</v-icon>
              Skip missing products
            </v-btn>
            <p class="text-caption grey--text ml-1">Only fully resolved products included</p>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="downloadConfirmDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </skutopia>
</template>

<script>
import router from '@/router'
import store from '@/store'
import { onMounted, ref, watch, computed, onUnmounted } from '@vue/composition-api'

import {
    mdiCartOutline,
    mdiDownload,
    mdiImageAlbum,
    mdiDotsVertical,
    mdiLayersTripleOutline,
    mdiSquareEditOutline,
    mdiTrayArrowUp,
    mdiLocationExit,
    mdiFileWordOutline,
    mdiViewGrid,
    mdiViewList,
    mdiCameraOff,
    mdiFormatListBulletedSquare,
    mdiMagnify,
    mdiAlertCircle,
    mdiClose,
    mdiPackageVariant,
    mdiPencil,
    mdiChevronUp,
    mdiChevronDown,
    mdiCloseBoxMultipleOutline
} from '@mdi/js';

import skutopiaStoreModule from '@/views/apps/skutopia/skutopiaStoreModule'
import useProduct from '@/views/apps/skutopia/product/useProduct'
import Skutopia from '@/views/apps/skutopia/Skutopia.vue'
import PNGDownloadEdit from './PNGDownloadEdit.vue'
import { useRouter, formatDate } from '@core/utils'
import { avatarText } from '@core/utils/filter'
import usePOG from '../usePOG'
import SecureImage from '../../SecureImage.vue';

export default {
    components: {
        Skutopia,
        SecureImage,
        PNGDownloadEdit
    },
    setup() {
        const SKUTOPIA_APP_STORE_MODULE_NAME = 'app-skutopia'
        if (!store.hasModule(SKUTOPIA_APP_STORE_MODULE_NAME)) store.registerModule(SKUTOPIA_APP_STORE_MODULE_NAME, skutopiaStoreModule)

        onUnmounted(() => {
          if (store.hasModule(SKUTOPIA_APP_STORE_MODULE_NAME)) store.unregisterModule(SKUTOPIA_APP_STORE_MODULE_NAME)
        })

        const localPOG =  ref({})
        const POGProductHeader = ref([
            { text: 'BAY', value: 'bay' },
            { text: 'CODE', value: 'shelf_code' },
            { text: 'PRODUCT', value: 'product' },
            { text: 'PRICE', value: 'price' },
            { text: 'FAC.', value: 'facings' },
            { text: 'STACK.', value: 'stackings' },
            { text: 'DEP.', value: 'depths' },
            { text: 'DIGITAL', value: 'digital' },
            { text: 'LAST UPLOADED', value: 'uploaded_at', sortable: false }
        ])

        const { route } = useRouter()
        const { addProduct } = useProduct()
        const shelfImage = ref(null)
        const currencyFormatter = ref(null)
        const isPNGDownload = ref(false)
        const isProductListEdit = ref(false)
        const pogFiles = ref([])
        const isPOGEdit = ref(false)
        const selectedImage = ref({})
        const overlayOpen = ref(false)
        const isCardView = ref(true)
        const isDeleteConfirmDialogVisible = ref(false)

        const resolveSnackbar = ref({
          show: false,
          message: '',
          color: 'error',
        })

        const showResolveError = (message) => {
          resolveSnackbar.value = { show: true, message, color: 'error' }
        }

        const {
            loadPOGData,
            planogram,
            pogStatus,
            downloadLoading,
            imageLoading,
            planogramUploadLoading,
            pogLoading,
            resolveStatus,
            addPOGShelfImage,
            fetchPOG,
            editPOG,
            deletePOG,
            downloadMissingProducts,
            downloadDOCXProducts,
            downloadPOGPSD,
            downloadPNG,
            downloadDecipherPNG,
            downloadPOGXLSX,
            updatePOGProduct
        } = usePOG()

        const resolveSearchLoading = ref({}) 
        const activeResolveItem = ref(null)
        const isResolveDialogOpen = ref(false)
        const resolveLoading = ref(false)
        const resolveSubmitting = ref(false)
        const resolveDecisions = ref({})      
        const resolveCandidates = ref({})     
        const resolveSearchInputs = ref({})

        const manualEntryOpen = ref({})
        const manualEntry = ref({})
        const manualSearchLoading = ref({})
        const manualSearchDone = ref({})
        const manualSearchResults = ref({})
        const manualSaveLoading = ref({})
        const downloadConfirmDialog = ref(false)

        const confirmDownloadPOG = async (includeMissing) => {
            downloadConfirmDialog.value = false
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPOGXLSX(pog, includeMissing)
        }

        const searchWithManualUPC = async (pp) => {
          const upc = manualEntry.value[pp.id].upc
          if (!upc || upc.length < 4) return

          manualSearchLoading.value = { ...manualSearchLoading.value, [pp.id]: true }
          manualSearchDone.value = { ...manualSearchDone.value, [pp.id]: false }
          manualSearchResults.value = { ...manualSearchResults.value, [pp.id]: [] }

          try {
            const results = await store.dispatch('app-skutopia/searchProducts', upc)
            manualSearchResults.value = {
              ...manualSearchResults.value,
              [pp.id]: results.map(p => ({
                id: p.id,
                barcode: p.barcode,
                name: p.name,
                brand: p.brand ? p.brand.name : '',
                thumbnail: p.images && p.images.length
                  ? p.images.find(i => i.is_current)?.thumbnail || p.images[0].thumbnail
                  : null
              }))
            }
            manualSearchDone.value = { ...manualSearchDone.value, [pp.id]: true }
          } catch (e) {
            console.error('Manual search error:', e)
          } finally {
            manualSearchLoading.value = { ...manualSearchLoading.value, [pp.id]: false }
          }
        }

        const toggleManualEntry = (ppId) => {
            const pp = unresolvedProducts.value.find(p => p.id === ppId)
            if (!manualEntry.value[ppId]) {
                manualEntry.value = {
                    ...manualEntry.value,
                    [ppId]: {
                        upc: pp ? pp.pending_upc : '',
                        name: pp ? pp.pending_variant || '' : '',
                    }
                }
            }
            manualEntryOpen.value = {
                ...manualEntryOpen.value,
                [ppId]: !manualEntryOpen.value[ppId]
            }
        }

        const confirmManualEntry = async (pp) => {
          const entry = manualEntry.value[pp.id]
          if (!entry.upc || !entry.name) return

          manualSaveLoading.value = { ...manualSaveLoading.value, [pp.id]: true }

          try {
            const response = await store.dispatch('app-skutopia/resolvePOGProducts', {
              id: localPOG.value.id,
              resolutions: [{
                planogram_product_id: pp.id,
                confirmed_product_id: null,
                create_product: true,
                is_excluded: false,
                manual_upc: entry.upc,
                manual_name: entry.name,
              }]
            })

            const createdList = response.data.created || []
            const errorList = response.data.errors || []

            if (createdList.length) {
              resolveDecisions.value = {
                ...resolveDecisions.value,
                [pp.id]: {
                  planogram_product_id: pp.id,
                  confirmed_product_id: createdList[0].product_id,
                  confirmed_name: entry.name,
                  confirmed_barcode: entry.upc,
                  create_product: false,
                  is_excluded: false,
                  thumbnail: null,
                }
              }
              manualEntryOpen.value = { ...manualEntryOpen.value, [pp.id]: false }
              manualSearchResults.value = { ...manualSearchResults.value, [pp.id]: [] }
              manualSearchDone.value = { ...manualSearchDone.value, [pp.id]: false }

              const nextUnresolved = unresolvedProducts.value.find(
                p => p.id !== pp.id && !resolveDecisions.value[p.id]
              )
              activeResolveItem.value = nextUnresolved ? nextUnresolved.id : null

            } else if (errorList.length) {
              console.error('Create product error:', errorList[0].error)
              const error = errorList[0].error
              const upc = entry.upc

              if (error.includes('already exists')) {
                showResolveError(
                  `A product with UPC ${upc} already exists. Please use the search to find and confirm it.`
                )
              } else {
                showResolveError(error)
              }
            }

          } catch (e) {
            console.error('Manual entry error:', e)
          } finally {
            manualSaveLoading.value = { ...manualSaveLoading.value, [pp.id]: false }
          }
        }

        const toggleResolveItem = (ppId) => {
          activeResolveItem.value = activeResolveItem.value === ppId ? null : ppId
        }

        const unresolvedProducts = computed(() =>
          (localPOG.value.products || []).filter(pp => !pp.product)
        )

        const resolveConfirmations = computed(() => Object.keys(resolveDecisions.value))

        const resolveAllDone = computed(() =>
          unresolvedProducts.value.length > 0 &&
          resolveConfirmations.value.length === unresolvedProducts.value.length
        )

        const markRemainingResolveAsManualEntry = () => {
          const updatedDecisions = { ...resolveDecisions.value }
          
          unresolvedProducts.value.forEach(pp => {
            if (!updatedDecisions[pp.id]) {
              updatedDecisions[pp.id] = {
                planogram_product_id: pp.id,
                confirmed_product_id: null,
                create_product: true,
                is_excluded: false,
                manual_name: pp.pending_variant,
                manual_upc: pp.pending_upc
              }
            }
          })
          resolveDecisions.value = updatedDecisions
        }

        watch(isResolveDialogOpen, async val => {
          if (val) {
            resolveDecisions.value = {}
            resolveSearchInputs.value = {}
            resolveCandidates.value = {}
            resolveLoading.value = true
            manualSearchLoading.value = {}
            manualSearchDone.value = {}
            manualSearchResults.value = {}
            manualSaveLoading.value = {}

            activeResolveItem.value = unresolvedProducts.value.length 
              ? unresolvedProducts.value[0].id 
              : null

            try {
              const response = await store.dispatch('app-skutopia/validatePOGProducts', localPOG.value.id)
              const rows = response.data

              unresolvedProducts.value.forEach(pp => {
                  resolveSearchInputs.value = { ...resolveSearchInputs.value, [pp.id]: pp.pending_upc || '' }
                  const row = rows.find(r => r.shelf === pp.shelf_code && r.upc === pp.pending_upc)
                  if (row && row.matches.length) {
                      resolveCandidates.value = { ...resolveCandidates.value, [pp.id]: row.matches }
                  } else {
                      resolveCandidates.value = { ...resolveCandidates.value, [pp.id]: [] }
                  }
              })
            } catch (e) {
              console.error('Error loading resolve candidates:', e)
            } finally {
              resolveLoading.value = false
            }
          }
        })

        let searchDebounceTimer = null
        const searchResolveProduct = async (ppId) => {
            const query = resolveSearchInputs.value[ppId]
            if (!query || query.length < 3) return

            clearTimeout(searchDebounceTimer)
            searchDebounceTimer = setTimeout(async () => {
                resolveSearchLoading.value = { ...resolveSearchLoading.value, [ppId]: true }
                try {
                    const results = await store.dispatch('app-skutopia/searchProducts', query)
                    resolveCandidates.value = {
                        ...resolveCandidates.value,
                        [ppId]: results.map(p => ({
                            id: p.id,
                            barcode: p.barcode,
                            name: p.name,
                            brand: p.brand ? p.brand.name : '',
                            thumbnail: p.images && p.images.length
                                ? p.images.find(i => i.is_current)?.thumbnail || p.images[0].thumbnail
                                : null
                        }))
                    }
                } catch (e) {
                    console.error('Search error:', e)
                } finally {
                    resolveSearchLoading.value = { ...resolveSearchLoading.value, [ppId]: false }
                }
            }, 400)
        }

        const resolveSelectMatch = (pp, match) => {
          if (resolveDecisions.value[pp.id] && resolveDecisions.value[pp.id].confirmed_product_id === match.id) {
            const updated = { ...resolveDecisions.value }
            delete updated[pp.id]
            resolveDecisions.value = updated
            return
          }

          resolveDecisions.value = {
            ...resolveDecisions.value,
            [pp.id]: {
              planogram_product_id: pp.id,
              confirmed_product_id: match.id,
              confirmed_name: match.name,
              confirmed_barcode: match.barcode,
              create_product: false,
              is_excluded: false,
              thumbnail: match.thumbnail,
            },
          }

          manualEntryOpen.value = { ...manualEntryOpen.value, [pp.id]: false }
          manualSearchResults.value = { ...manualSearchResults.value, [pp.id]: [] }
          manualSearchDone.value = { ...manualSearchDone.value, [pp.id]: false }
          if (manualEntry.value[pp.id]) {
            manualEntry.value = {
              ...manualEntry.value,
              [pp.id]: { upc: '', name: '' }
            }
          }

          const nextUnresolved = unresolvedProducts.value.find(
            p => p.id !== pp.id && !resolveDecisions.value[p.id]
          )
          activeResolveItem.value = nextUnresolved ? nextUnresolved.id : null
        }

        const resolveMarkExcluded = (pp) => {
          resolveDecisions.value = {
              ...resolveDecisions.value,
              [pp.id]: {
              planogram_product_id: pp.id,
              confirmed_product_id: null,
              create_product: false,
              is_excluded: true, // Marked as parked/not found
              }
          }
        }

        const submitResolutions = async () => {
          resolveSubmitting.value = true
          try {
            const resolutions = Object.values(resolveDecisions.value).map(decision => ({
              planogram_product_id: decision.planogram_product_id,
              confirmed_product_id: decision.confirmed_product_id,
              create_product: decision.create_product || false,
              is_excluded: decision.is_excluded || false,
              manual_upc: decision.manual_upc,
              manual_name: decision.manual_name
            }))

            await store.dispatch('app-skutopia/resolvePOGProducts', {
              id: localPOG.value.id,
              resolutions,
            })

            await fetchPOG(localPOG.value.id)
            isResolveDialogOpen.value = false

          } catch (e) {
            console.error('Resolution error:', e)
          } finally {
            resolveSubmitting.value = false
          }
        }

        const init = () => {
            localPOG.value = JSON.parse(JSON.stringify(planogram.value))
            const firstWithCurrency = (localPOG.value.products || []).find(p => p.currency)
            if (firstWithCurrency) {
                currencyFormatter.value = new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: firstWithCurrency.currency
                })
            } else {
                currencyFormatter.value = new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'GBP'
                })
            }
        }

        const productsData = computed(() => localPOG.value.products || [])
        const missingProducts = computed(() => localPOG.value.missing_images || [])
        
        const uploadShelfImage = async(file) => {
            const formImageData = new FormData()
            formImageData.append('shelf_image', file)
            const response = await addPOGShelfImage(localPOG.value.id, file)
            localPOG.value.shelf_thumbnail = response.shelf_thumbnail
        }

        const downloadPSD = async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPOGPSD(pog)
        }

        const downloadPOG = async () => {
            if (localPOG.value.status === 'INCO' && unresolvedProducts.value.length > 0) {
                downloadConfirmDialog.value = true
                return
            }
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPOGXLSX(pog)
        }

        const downloadPNGs = async (sides) => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPNG(pog, sides)
        }

        const downloadDecipherPNGs = async (sides) => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadDecipherPNG(pog, sides)
        }
        
        const downloadMissing = async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            downloadMissingProducts(pog)
        }

        const downloadDocx = async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            downloadDOCXProducts(pog)
        }

        const cancelProductListEdit = () => {
            pogFiles.value = []
            isProductListEdit.value = false
        }

        const uploadProductList = async () => {
            const payload = {
                excel_file: pogFiles.value[0]
            }

            localPOG.value = await editPOG(localPOG.value.id, payload)
            pogFiles.value = []
            isProductListEdit.value = false

            validationPlanogramId.value = localPOG.value.id
            // POGView doesn't manage validation dialog internally, but we can rely on POGValidationDialog injected elsewhere if needed
        }

        const cancelPOGEdit = () => {
            isPOGEdit.value = false
        }

        const updatePOG = async() => {
            const payload = {
                status: localPOG.value.status,
                comments: localPOG.value.comments
            }

            localPOG.value = await editPOG(localPOG.value.id, payload)
            isPOGEdit.value = false
        }

        const handleDigitalChange = (pogProduct) => {
            const newPOGProduct = {
                id: pogProduct.id,
                digital: pogProduct.digital
            }
            updatePOGProduct(newPOGProduct)
        }


        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            input.onchange = _ => {
                pogFiles.value = Array.from(input.files);
            };
            input.click();
        }

        const downloadShelf = () => {
            // Placeholder method from existing code
        }

        const onFileChange = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*'
            input.onchange = (_) => {
                const image = Array.from(input.files)[0];
                if (!image) {
                    return;
                }
                uploadShelfImage(image);
            };
            input.click();
        }


        const openOverlay = (image) => {
            selectedImage.value = image;
            overlayOpen.value = true;
        }

        const closeOverlay = () =>  {
            overlayOpen.value = false;
            selectedImage.value = null;
        }

        const deletePOGConfirmed = async(pog_id) => {
            await deletePOG(pog_id)
            router.push({ name: 'planogram-list' })
        }

        onMounted(async () => {
            await fetchPOG(route.value.params.id)
        })

        watch(planogram, () => {
            init()
        })

        return {
            localPOG,
            loadPOGData,
            POGProductHeader,
            productsData,
            missingProducts,
            imageLoading,
            shelfImage,
            downloadLoading,
            currencyFormatter,
            isProductListEdit,
            pogFiles,
            pogStatus,
            planogramUploadLoading,
            isPOGEdit,
            isPNGDownload,
            isDeleteConfirmDialogVisible,
            selectedImage,
            overlayOpen,
            pogLoading,
            isCardView,
            
            resolveStatus,
            cancelProductListEdit,
            downloadMissing,
            downloadDocx,
            downloadPSD,
            downloadPNGs,
            downloadDecipherPNGs,
            downloadPOG,
            downloadShelf,
            uploadProductList,
            closeOverlay,
            openOverlay,
            handleDigitalChange,
            cancelPOGEdit,
            updatePOG,
            deletePOGConfirmed,
            onFileChange,
            openFile,
            formatDate,
            avatarText,
            isResolveDialogOpen,
            resolveLoading,
            resolveSubmitting,
            resolveDecisions,
            resolveCandidates,
            resolveSearchInputs,
            unresolvedProducts,
            resolveConfirmations,
            resolveAllDone,
            markRemainingResolveAsManualEntry,
            searchResolveProduct,
            resolveSelectMatch,
            resolveMarkExcluded,
            submitResolutions,
            resolveSearchLoading,
            activeResolveItem,
            toggleResolveItem,
            manualEntryOpen,
            manualEntry,
            toggleManualEntry,
            confirmManualEntry,
            manualSearchLoading,
            manualSearchDone,
            manualSearchResults,
            manualSaveLoading,
            searchWithManualUPC,
            resolveSnackbar,
            downloadConfirmDialog,
            confirmDownloadPOG,

            icons: {
                mdiCartOutline,
                mdiImageAlbum,
                mdiDotsVertical,
                mdiDownload,
                mdiLayersTripleOutline,
                mdiSquareEditOutline,
                mdiTrayArrowUp,
                mdiLocationExit,
                mdiFileWordOutline,
                mdiViewGrid,
                mdiViewList,
                mdiCameraOff,
                mdiFormatListBulletedSquare,
                mdiMagnify,
                mdiAlertCircle,
                mdiClose,
                mdiPackageVariant,
                mdiPencil,
                mdiChevronUp,
                mdiChevronDown,
                mdiCloseBoxMultipleOutline
            }
        }
    }
}
</script>

<style scoped>
.text-high-emphasis {
    color: rgba(46, 38, 61, 0.9) !important;
}

.v-file-input {
    grid-template-areas: none !important;
}
.v-input__prepend-outer {
    margin-top: 0px !important;
}

.drop-zone {
  border: 1px dashed rgba(33,33,33, 0.4);
}
</style>